import { ReactNode } from 'react';
import { Heading } from '@core/ui';

export const AnalyticsCard = ({ children, heading }: { children: ReactNode, heading: string }) => (
    <div className="bg-white rounded-lg p-6">
        <Heading variant="h2" styleAs="h4" classNames="mb-2">{heading}</Heading>
        {children}
    </div>
);
